import { render, staticRenderFns } from "./M2m_S10.vue?vue&type=template&id=077a17d8&scoped=true"
import script from "./M2m_S10.vue?vue&type=script&lang=js"
export * from "./M2m_S10.vue?vue&type=script&lang=js"
import style0 from "./M2m_S10.vue?vue&type=style&index=0&id=077a17d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077a17d8",
  null
  
)

export default component.exports